import React from 'react'
import axios from 'axios'
import { Modal, message } from 'antd'

const DeleteMiniappBanner = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const { oid, title } = props.data

  const handleOk = () => {
    axios.post('/p/deco/banner/delete', { 
      merchant_oid: merchantOid, 
      banner_oid: oid 
    })
      .then(function (response) {
        if (response.errcode === 0) {
          message.success('横幅广告删除成功！')
          props.isCancel()
          props.getBannerList()
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  return (
    <Modal 
      title="删除横幅广告"
      open={props.isOpen}
      onOk={handleOk}
      onCancel={props.isCancel}
      cancelText="取消"
      okType='danger'
      okText='删除'>

      <p>正在将横幅广告
        <span style={{color: '#005dff'}}>《{title}》</span>
        从列表中移除，此操作不可逆，是否确认删除？
      </p>
    </Modal>
  )
}

export default DeleteMiniappBanner
